import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { ResetPinCodeService } from '@pg-app/auth/services/reset-pin-code.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

function comparePin(c: AbstractControl) {
  const v = c.value;
  return v.pin === v.pinConfirm
    ? null
    : {
      pinnotmatch: true
    };
}
@Component({
  selector: 'np-change-pin',
  templateUrl: './change-pin.component.html',
  styleUrls: ['./change-pin.component.scss']
})
export class ChangePinComponent implements OnInit {
  changePinForm: FormGroup;
  wrongPin: boolean;
  destroy$ = new Subject<boolean>();
  get pinCtrl() {
    return this.changePinForm.get('pin') as FormControl;
  }

  get confirmPinCtrl() {
    return this.changePinForm.get('pinConfirm') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginInfo: LoginInfoService,
    private resetPinCodeService: ResetPinCodeService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.changePinForm = this.fb.group(
      {
        pin: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(6)])],
        pinConfirm: ''
      },
      {
        validator: comparePin
      }
    );
    this.pinCtrl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.checkPin(value);
    });
  }

  onSubmit() {
    if (this.changePinForm.valid && !this.wrongPin) {
      this.resetPinCodeService
        .changePinCode({
          newPin: this.pinCtrl.value,
          tokenHash: this.loginInfo.tokenHash,
          confirmNewPin: this.confirmPinCtrl.value
        })
        .subscribe(
          res => {
            this.toastr.success('Reset Memorable Number successfully!');
            this.router.navigate(['auth/login']);
          }
        );
    }
  }

  checkPin(pin) {
    for (let i = 0; i < pin.length - 2; i++) {
      if (
        (pin.charCodeAt(i) + 1 === pin.charCodeAt(i + 1) && pin.charCodeAt(i) + 2 === pin.charCodeAt(i + 2)) ||
        (pin.charCodeAt(i) === pin.charCodeAt(i + 1) && pin.charCodeAt(i) === pin.charCodeAt(i + 2)) ||
        (pin.charCodeAt(i) - 1 === pin.charCodeAt(i + 1) && pin.charCodeAt(i) - 2 === pin.charCodeAt(i + 2))
      ) {
        this.wrongPin = true;
        return;
      }
    }
    this.wrongPin = false;
  }
}
